
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/landing/win-a-virgin-gift-card",
      function () {
        return require("private-next-pages/landing/win-a-virgin-gift-card.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/landing/win-a-virgin-gift-card"])
      });
    }
  